var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.29 16.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".f{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M12.6,11.19c.05-.05,.09-.11,.13-.17,1.26-1.84,1.58-3.88,.97-6.04-.34-1.2-1.02-2.29-1.97-3.13h-.01C9.87,.2,7.7-.35,5.28,.22c-1.34,.32-2.56,1.05-3.44,2.06C.12,4.23-.4,6.5,.3,9.04c.26,.88,.7,1.71,1.34,2.46l.02,.02s.01,.02,.03,.03c.02,.03,.04,.05,.07,.08l.54,.57,.25,.21c.14,.11,.29,.23,.45,.34,1.25,.84,2.57,1.26,3.95,1.26,.78,0,1.59-.14,2.42-.42,.66-.23,1.26-.55,1.82-.99l3.68,3.69,1.42-1.41-3.69-3.69Zm-3.88,.51c-1.65,.55-3.16,.35-4.59-.6-.12-.08-.22-.17-.34-.26l-.12-.09-.47-.5c-.45-.51-.79-1.13-.98-1.76-.51-1.85-.15-3.45,1.12-4.89,.62-.7,1.47-1.21,2.4-1.43,1.77-.42,3.29-.03,4.66,1.17,.66,.59,1.14,1.35,1.37,2.19,.46,1.59,.23,3.01-.68,4.35-.07,.1-.15,.2-.23,.3l-.61,.62c-.44,.39-.97,.7-1.53,.9Z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.9dadf8e2a27952d3062cd6a7ff15dbb7.svg";
export { ForwardRef as ReactComponent };